import z from "zod";

export const patchCalculationLockSchema = z.object({
	isLocked: z.boolean(),
});

export type PatchCalculationLockSchema = z.infer<typeof patchCalculationLockSchema>;
